import type { ReactNode } from "react";

// The light entry point: the package root would pull in the charts.
import { Pagination, needsPager, useClientPage } from "@strat/ui/pagination";

/**
 * A list that shows one page at a time: an activity feed, a log, saved items.
 * The pager appears only once there are more items than the smallest page.
 */
export function PagedList<T>({
  items,
  render,
  pageSize,
  className,
  resetKey,
}: {
  items: readonly T[];
  render: (item: T, index: number) => ReactNode;
  pageSize?: number;
  className?: string;
  /** Back to page one when this changes, such as a new filter or scope. */
  resetKey?: unknown;
}) {
  const page = useClientPage(items, { initialLimit: pageSize, resetKey });
  return (
    <>
      <ul className={className}>{page.pageItems.map((item, i) => render(item, i))}</ul>
      {needsPager(items.length) && <Pagination {...page.pager} />}
    </>
  );
}
